module.exports = __webpack_public_path__ + "static/media/scheduler_media_catalog.cbf951ff.xlsx";